module.exports = __webpack_public_path__ + "media/images/icons/outlined/qrcode-50929ca7038f86f618e1df3dd5c42b5e.svg";